import type { EnumUnion } from "@dresscode-frontend/utility-types";
import type { EquipmentListItem } from "../../../-api";

type EquipmentTableEquipmentColumn = Pick<
  EquipmentListItem,
  "id" | "name" | "equipmentTypeName"
>;

type EquipmentTypeInfo = {
  typeName: string;
  itemName?: string;
};

type Person = {
  id?: string;
  name?: string;
  avatarUrl?: string;
  email?: string;
};

export const EquipmentTableColumns = {
  EQUIPMENT: "EQUIPMENT",
  EQUIPMENT_TYPE: "EQUIPMENT_TYPE",
  MODEL: "MODEL",
  SERIAL_NUMBER: "SERIAL_NUMBER",
  ASSET_TAG: "ASSET_TAG",
  ASSIGNED_PERSON: "ASSIGNED_PERSON",
  ASSIGNED_PLACE: "ASSIGNED_PLACE",
  CREATED_AT: "CREATED_AT",
} as const;
export type EquipmentTableColumns = EnumUnion<typeof EquipmentTableColumns>;

export type EquipmentTableRowData = {
  [EquipmentTableColumns.EQUIPMENT]: EquipmentTableEquipmentColumn;
  [EquipmentTableColumns.EQUIPMENT_TYPE]: EquipmentTypeInfo;
  [EquipmentTableColumns.MODEL]: string | undefined;
  [EquipmentTableColumns.SERIAL_NUMBER]: string | undefined;
  [EquipmentTableColumns.ASSET_TAG]: string | undefined;
  [EquipmentTableColumns.ASSIGNED_PERSON]: Person | null;
  [EquipmentTableColumns.ASSIGNED_PLACE]: string | undefined;
  [EquipmentTableColumns.CREATED_AT]: string;
};

export const convertEquipmentItemToTableRow = (
  item: EquipmentListItem,
): EquipmentTableRowData => {
  return {
    [EquipmentTableColumns.EQUIPMENT]: {
      id: item.id,
      name: item.name,
      equipmentTypeName: item.equipmentTypeName,
    },
    [EquipmentTableColumns.EQUIPMENT_TYPE]: {
      typeName: item.equipmentTypeName,
      itemName: item.equipmentItemName,
    },
    [EquipmentTableColumns.MODEL]: item.model,
    [EquipmentTableColumns.SERIAL_NUMBER]: item.serialNumber,
    [EquipmentTableColumns.ASSET_TAG]: item.assetTag,
    [EquipmentTableColumns.ASSIGNED_PERSON]: item.assignedPerson
      ? {
          id: item.assignedPerson.personId,
          name: item.assignedPerson.name,
          avatarUrl: item.assignedPerson.avatarUrl,
          email: undefined,
        }
      : null,
    [EquipmentTableColumns.ASSIGNED_PLACE]: item.assignedPlace?.placeLabel,
    [EquipmentTableColumns.CREATED_AT]: item.createdAt,
  };
};
